var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRename(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.14094 0C2.97434 3.20828e-05 2.81458 0.0662314 2.69679 0.184039L0.184039 2.69679C0.0662314 2.81458 3.20828e-05 2.97434 0 3.14094V13.1919C1.66576e-05 13.3585 0.0662059 13.5183 0.18401 13.6361C0.301815 13.7539 0.461587 13.8201 0.628188 13.8201H10.6792C10.8458 13.8201 11.0056 13.7539 11.1234 13.6361C11.2412 13.5183 11.3074 13.3585 11.3074 13.1919V8.94922L8.24251 12.0141C7.88973 12.3669 7.41145 12.5655 6.91252 12.5662H5.65492C5.40692 12.5665 5.16131 12.5179 4.93215 12.4231C4.70299 12.3283 4.49479 12.1892 4.31949 12.0137C4.14419 11.8383 4.00523 11.63 3.91058 11.4008C3.81593 11.1716 3.76744 10.926 3.7679 10.678V9.42159C3.76832 8.92223 3.96689 8.44345 4.32002 8.09037L10.6031 1.80727C10.802 1.60901 11.0426 1.45768 11.3074 1.36435V0.628188C11.3074 0.461587 11.2412 0.301815 11.1234 0.18401C11.0056 0.0662059 10.8458 1.66576e-05 10.6792 0H3.14094ZM11.9245 2.51275C11.7622 2.5175 11.6083 2.58287 11.4939 2.69802L5.20954 8.97621C5.09095 9.09398 5.02442 9.25444 5.02427 9.42159V10.678C5.02294 11.0268 5.30606 11.3099 5.65492 11.3086H6.91252C7.07806 11.3073 7.23631 11.2409 7.35299 11.1233L13.6361 4.84023C13.8796 4.59521 13.8796 4.19942 13.6361 3.95439L12.3797 2.69802C12.2596 2.57717 12.0949 2.51038 11.9245 2.51275Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRename);
export default __webpack_public_path__ + "static/media/rename.d0496665b54faf46827a2816184cc4ac.svg";
export { ForwardRef as ReactComponent };